import React, { useState } from 'react';
import OverviewTab from './tabs/OverviewTab';
import CategoriesTab from './tabs/CategoriesTab';
import TrendsTab from './tabs/TrendsTab';
import AIInsightsTab from './tabs/AIInsightsTab';

const AnalyticsTabs = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'categories', label: 'Categories' },
    { id: 'trends', label: 'Trends' },
    { id: 'ai-insights', label: 'AI Insights' }
  ];

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <div className="flex overflow-x-auto border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 text-sm font-medium whitespace-nowrap ${
              activeTab === tab.id
                ? 'text-indigo-600 border-b-2 border-indigo-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === 'overview' && <OverviewTab />}
        {activeTab === 'categories' && <CategoriesTab />}
        {activeTab === 'trends' && <TrendsTab />}
        {activeTab === 'ai-insights' && <AIInsightsTab />}
      </div>
    </div>
  );
};

export default AnalyticsTabs; 